export default "/assets/d1b7432105a680b9.svg"